export default __webpack_public_path__ + "static/media/mobileWef3.491cc769.png";